import { ZendeskArticle, ZendeskCategory } from 'interfaces/ZendeskArticle';
import { useQuery } from '@tanstack/react-query';

import { MyToverAPI } from 'api/MyToverAPI';

export interface ContentResult {
  type: 'article' | 'category';
  data: ZendeskArticle | ZendeskCategory;
}

export const contentKeys = {
  resolve: (content: string, locale?: string) => ['content', content, locale] as const,
};

export const useContent = (content: string, locale?: string) =>
  useQuery<ContentResult>({
    queryKey: contentKeys.resolve(content, locale),
    queryFn: () => MyToverAPI.getContent(content, locale).then((r) => r.parsed as ContentResult),
    enabled: !!content,
  });
